import { render, staticRenderFns } from "./ClientMonetariesTable.vue?vue&type=template&id=6ba05e9c&scoped=true&"
import script from "./ClientMonetariesTable.vue?vue&type=script&lang=js&"
export * from "./ClientMonetariesTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientMonetariesTable.vue?vue&type=style&index=0&id=6ba05e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba05e9c",
  null
  
)

export default component.exports